<template>
    <div
        v-if="totalRef > 0"
        class="tw:flex tw:flex-col tw:w-full tw:sm:flex-row-reverse tw:sm:items-center tw:sm:justify-between tw:gap-3"
    >
        <PaginationFront
            :value="currentPage"
            :total="totalRef"
            :per-page="perPageRef"
            @input="changePage"
        />
        <div class="tw:w-full tw:flex tw:items-center tw:gap-4"
             :class="totalPages > 1 ? 'tw:justify-between tw:sm:justify-start' : 'tw:justify-between'"
        >
            <PaginationPerPageFront
                :value="perPageRef"
                :options="perPageOptions !== null ? perPageOptions : undefined"
                @input="changePerPage"
            />
            <PaginationResultsFront
                :from="rangeFrom"
                :to="rangeTo"
                :total="totalRef"
                :current-page="currentPage"
                :total-pages="totalPages"
            />
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import PaginationFront from '@/modules/front/ui/pagination/PaginationFront.vue';
    import PaginationPerPageFront from '@/modules/front/ui/pagination/PaginationPerPageFront.vue';
    import PaginationResultsFront from '@/modules/front/ui/pagination/PaginationResultsFront.vue';
    import { usePagination } from '@/composables/front/common/usePagination';

    const props = defineProps({
        page: {
            type: Number,
            default: 1
        },
        perPage: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        },
        perPageOptions: {
            type: Array,
            default: null
        }
    });

    const emit = defineEmits(['update:page', 'change:per-page']);
    const currentPageRef = computed(() => props.page    || 1);
    const perPageRef     = computed(() => props.perPage || 10);
    const totalRef       = computed(() => props.total   || 0);

    const {
        totalPages,
        currentPage,
        rangeFrom,
        rangeTo,
    } = usePagination(currentPageRef, totalRef, perPageRef);

    function changePage(page) {
        emit('update:page', page);
    }

    function changePerPage(newPerPage) {
        emit('change:per-page', { page: 1, perPage: newPerPage });
    }
</script>
